$(document).ready(function () {
    // Open the modal and load content
    $("#openModal").click(function () {
      const content = window.donationContent;
      $("#modal-body").html(content); // Load the content into the modal body
      $("#customModal").show();; // Show the modal
      $("body").addClass("overflow-hidden");
    //   $("body").addClass("w-full");
    });

    // Close the modal
    $(".close").click(function () {
        $("body").removeClass("overflow-hidden");
        // $("body").removeClass("w-full");
      $("#customModal").hide();
      
    });

    // Close the modal when clicking outside the modal content
    $(window).click(function (event) {
      if ($(event.target).is("#customModal")) {
        // $("body").removeClass("fixed");
        // $("body").removeClass("w-full");
        $("#customModal").hide();
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
   
    const checkbox = document.querySelector('#add-to-cart-checkbox');
    const loader = document.querySelector('#loader1'); // The loader element

    if (checkbox && loader) {
        // Initially check the cart for "Go Green" donation item
        checkGoGreenDonation();

        checkbox.addEventListener('change', async function () {
            if (checkbox.checked) {
                showLoader();

                const success = await addToCart();

                hideLoader();
                if (!success) {
                    checkbox.checked = false; 
                }
            } else {
                showLoader();

                const success = await removeFromCart();

                hideLoader();
                if (!success) {
                    checkbox.checked = true; 
                }
            }
        });
    } else {
        console.error('Checkbox element or loader not found!');
    }

    function showLoader() {
        loader.style.display = 'block'; 
    }

    function hideLoader() {
        loader.style.display = 'none';
    }

    async function addToCart() {
        try {
            const variantId = variant_Id; 
            if (!variantId) {
                throw new Error('Variant ID is not valid');
            }

            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: 1
                })
            });

            if (!response.ok) {
                throw new Error(`Failed to add item to cart: ${response.statusText}`);
            }

            const data = await response.json();
            
            // After adding the item to the cart, check if the Go Green donation is available
            await checkGoGreenDonation();
            window.location.reload(); 
            return true; 
        } catch (error) {
            console.error('Error adding item to cart:', error);
            return false; 
        }
    }

    // Function to remove an item from the Shopify cart
    async function removeFromCart() {
        try {
            const variantId = variant_Id;

            const response = await fetch('/cart.js');
            const cart = await response.json();

            const item = cart.items.find(item => item.variant_id === variantId);

            if (item) {
                const updateResponse = await updateCartItemQuantity(item.id, 0);

                if (updateResponse) {
                    // After removing the item from the cart, check if the Go Green donation is available
                    await checkGoGreenDonation();
                    window.location.reload(); 
                    return true; 
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } catch (error) {
            console.error('Error removing item from cart:', error);
            return false;
        }
    }

    async function updateCartItemQuantity(lineId, quantity) {
        try {
            const response = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    updates: {
                        [lineId]: quantity
                    }
                })
            });

            if (response.ok) {
                const data = await response.json();
                return true;
            } else {
                console.error('Failed to update cart');
                return false;
            }
        } catch (error) {
            console.error('Error updating cart item quantity:', error);
            return false;
        }
    }

    // Function to check if the "Go Green" donation item is in the cart
    async function checkGoGreenDonation() {
        try {
            const response = await fetch('/cart.js');
            const cart = await response.json();

            // Check if the "Go Green" donation is in the cart by its variant ID or item title
            const goGreenItem = cart.items.find(item => item.title.toLowerCase().includes('go green'));

            if (goGreenItem) {
                // If found, check the checkbox
                checkbox.checked = true;
                const cartRemoveButtons = document.querySelectorAll('cart-remove-button');
            } else {
                // If not found, uncheck the checkbox
                checkbox.checked = false;
            }
        } catch (error) {
            console.error('Error checking cart:', error);
        }
    }
});

